import { render, staticRenderFns } from "./test-row.vue?vue&type=template&id=22aea494&"
import script from "./test-row.vue?vue&type=script&lang=js&"
export * from "./test-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports